export const ACCOUNT = 'account'
export const CURRENT_AWARENESS = 'ca'
export const CURRENT_AWARENESS_ARTICLE = 'currentawarenessarticle'
export const CURRENT_AWARENESS_PUBLICATIONS = 'currentawarenesspublications'
export const CURRENT_AWARENESS_REVIEW = 'careview'
export const COMMENTS = 'comments'
export const DASHBOARD = 'dashboard'
export const INSTRUCTION_VIDEO = 'instructionvideo'
export const LEGISLATION = 'legislation'
export const LEGISLATION_MENU = 'legislationmenu'
export const LEGISLATION_CATEGORIES = 'legislationcategories'
export const LEGISLATION_FOLDERS = 'legislationfolders'
export const LEGISLATION_REVIEW = 'legreview'
export const LOGIN = 'login'
export const NOT_FOUND = 'notFound'
export const OFFLINE_CONTENT = 'offlinecontent'
export const PRECEDENTS = 'precedents'
export const PRECEDENTS_CONTENT = 'precedentscontent'
export const PRECEDENTS_REVIEW = 'prereview'
export const PRECEDENTS_ALL = 'preall'
export const PRECEDENTS_AUTOMATED_LISTINGS = 'precedentsautomatedlistings'
export const DOCUMENTS = 'documents'
export const DOCUMENTS_CONTENT = 'documentscontent'
export const DOCUMENTS_REVIEW = 'docreview'
export const DOCUMENTS_ALL = 'docall'
export const DOCUMENTS_AUTOMATED_LISTINGS = 'documentsautomatedlistings'
export const DOCUMENTS_INTERVIEW = 'documentsinterview'
export const QA_CONTENT = 'qa'
export const QA_MENU = 'qamenu'
export const QA_REVIEW = 'qareview'
export const RELATED = 'related'
export const SEARCH = 'search'
export const SHARE = 'share'
export const STATIC = 'static'
export const UTILS = 'utils'
export const MW_OVERVIEW = 'mwoverview'
export const MW_LIST_DEALS = 'mwlistdeals'
export const MW_ANALYTICS = 'mwanalytics'
export const MW_DEAL_DETAILS = 'mwdealdetails'
export const MW_DEAL_COMPARE = 'mwdealcompare'
export const AOL_MENU = 'aolmenu'
export const USER_ADMIN = 'useradmin'
